(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.cart-drawer__panel');
      this.opener = null;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) {
          event.preventDefault();
          this.close();
          return;
        }
        const changeBtn = event.target.closest('[data-cart-change]');
        if (changeBtn) {
          this.changeLine(changeBtn.dataset.lineKey, changeBtn.dataset.lineQuantity);
          return;
        }
        const removeBtn = event.target.closest('[data-cart-remove]');
        if (removeBtn) {
          this.changeLine(removeBtn.dataset.lineKey, 0);
        }
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };

      this.onToggleClick = (event) => {
        const toggle = event.target.closest('[data-cart-toggle]');
        if (!toggle) return;
        event.preventDefault();
        this.opener = toggle;
        this.open();
      };
      document.addEventListener('click', this.onToggleClick);

      // The drop closed while items sat in the basket. This section renders on
      // every pageview from layout/theme.liquid, so this is the theme's only
      // reliable hook to empty a stale cart before it can reach /checkout.
      if (this.hasAttribute('data-drop-closed')) this.clearClosedDrop();
    }

    async clearClosedDrop() {
      this.removeAttribute('data-drop-closed');
      const sectionId = this.dataset.sectionId;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response = await fetch(`${root}cart/clear.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        this.render(data, sectionId);
        // The re-rendered section can't tell an emptied basket from one that
        // was already empty, so the explanation is injected here instead.
        const empty = this.querySelector('.cart-drawer__empty-text');
        if (empty) empty.textContent = 'The drop closed, so your basket was emptied.';
      } catch (error) {
        console.error('Closed-drop cart clear failed', error);
      }
    }

    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      if (this.panel) this.panel.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
    }

    async changeLine(key, quantity) {
      if (!key) return;
      const sectionId = this.dataset.sectionId;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.classList.add('is-loading');
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: Number(quantity),
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        this.render(data, sectionId);
      } catch (error) {
        console.error('Cart update failed', error);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    render(data, sectionId) {
      const html = data.sections && data.sections[sectionId];
      if (html) {
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-cart-body]');
        const current = this.querySelector('[data-cart-body]');
        if (fresh && current) current.replaceWith(fresh);
      }
      this.updateCount(data.item_count);
    }

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count < 1;
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites-drawer"]) return;
  try {
    
  class FavoritesDrawer extends HTMLElement {
    connectedCallback() {
      this.FAV_KEY = 'sylvie:favorites';
      this.NOTIFY_KEY = 'sylvie:notify_me';
      this.OWNER_KEY = 'sylvie:favorites_owner';
      this.panel = this.querySelector('.favorites-drawer__panel');
      this.body = this.querySelector('[data-fav-body]');
      this.footer = this.querySelector('[data-fav-footer]');
      this.opener = null;
      this._isProcessing = false;
      this._serverMode = this.dataset.customerLoggedIn === 'true';
      this.claimStorage();
      // Server state is authoritative only for authenticated customers. Guests
      // keep the local selections they made after choosing Continue as Guest.
      if (this._serverMode && window.sylvie_init_favorites) {
        this.writeFavs(window.sylvie_init_favorites);
      }
      if (this._serverMode && window.sylvie_init_notify_me) {
        this.writeNotify(window.sylvie_init_notify_me);
      }
      this.syncButtons();
      this.updateCount();
      // Every later syncButtons() also prunes the account grid. This first one
      // must not: the grid was rendered from the same server state the maps were
      // just hydrated from, and if that hydration ever failed the page would
      // erase itself instead of showing a stale card.
      this._hydrated = true;

      this.onKeydown = (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };
      document.addEventListener('click', (e) => this.onClick(e));
      var self = this;
      window.addEventListener('storage', (e) => {
        if (e.key === self.FAV_KEY || e.key === self.NOTIFY_KEY) {
          self.syncButtons();
          self.updateCount();
          if (self.classList.contains('is-open')) self.render();
        }
      });
    }

    // --- Storage ownership ---
    // The two maps below live in localStorage, which outlives the session, so
    // they have to record WHOSE they are. Without that, signing out left the
    // previous customer's favorites in the drawer, the badge lit, and their
    // hearts filled on every card — and the next person to sign in on the same
    // browser inherited them. The owner is the customer id while signed in and
    // '' for a guest; anything else means these maps belong to a different
    // session and must go before the page reads them.
    //
    // A missing owner is data written before this tracking existed: it is of
    // unknown origin, so it is dropped too. That costs a pre-existing guest
    // their local list once, which beats leaking a real customer's list to
    // whoever opens the browser next.
    claimStorage() {
      var current = this.dataset.customerId || '';
      if (localStorage.getItem(this.OWNER_KEY) === current) return;
      this.writeFavs({});
      this.writeNotify({});
      localStorage.setItem(this.OWNER_KEY, current);
    }

    // --- Favorites storage ---
    readFavs() {
      try {
        return JSON.parse(localStorage.getItem(this.FAV_KEY)) || {};
      } catch (e) {
        return {};
      }
    }
    writeFavs(map) {
      localStorage.setItem(this.FAV_KEY, JSON.stringify(map));
    }

    // --- Notify-me storage ---
    readNotify() {
      try {
        return JSON.parse(localStorage.getItem(this.NOTIFY_KEY)) || {};
      } catch (e) {
        return {};
      }
    }
    writeNotify(map) {
      localStorage.setItem(this.NOTIFY_KEY, JSON.stringify(map));
    }

    // --- Proxy URLs ---
    favProxyUrl() {
      return '/apps/proxy/favorites';
    }
    notifyProxyUrl() {
      return '/apps/proxy/notify-me';
    }

    // --- Proxy toggle (generic) ---
    proxyToggle(url, productId, isCurrentlySet) {
      var method = isCurrentlySet ? 'DELETE' : 'POST';
      return fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: productId }),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (data.error) {
            throw new Error(data.error.message);
          }
          return data;
        });
      });
    }

    // --- Button lock/unlock (prevents concurrent proxy calls) ---
    lockButtons(activeBtn) {
      this._isProcessing = true;
      // Show loader on active button (CSS handles hiding icon/text and showing loader)
      activeBtn.classList.add('is-loading');
      // Disable all other fav/notify buttons
      var allBtns = document.querySelectorAll('[data-fav-toggle-item], [data-notify-toggle]');
      for (var i = 0; i < allBtns.length; i++) {
        if (allBtns[i] !== activeBtn) {
          allBtns[i].classList.add('is-disabled');
        }
      }
    }

    unlockButtons(activeBtn) {
      this._isProcessing = false;
      // Remove loading state (CSS handles showing icon/text and hiding loader)
      activeBtn.classList.remove('is-loading');
      // Re-enable all other fav/notify buttons
      var allBtns = document.querySelectorAll('[data-fav-toggle-item], [data-notify-toggle]');
      for (var i = 0; i < allBtns.length; i++) {
        allBtns[i].classList.remove('is-disabled');
      }
    }

    onClick(e) {
      var self = this;
      // Block clicks while processing
      if (this._isProcessing) {
        e.preventDefault();
        return;
      }
      // Favorite toggle
      const toggle = e.target.closest('[data-fav-toggle-item]');
      if (toggle) {
        e.preventDefault();
        this.toggleFav(toggle);
        return;
      }
      // Notify-me toggle
      const notifyToggle = e.target.closest('[data-notify-toggle]');
      if (notifyToggle) {
        e.preventDefault();
        this.toggleNotify(notifyToggle);
        return;
      }
      // Drawer opener
      const opener = e.target.closest('[data-fav-open]');
      if (opener) {
        e.preventDefault();
        this.opener = opener;
        this.open();
        return;
      }
      // Drawer close
      if (e.target.closest('[data-fav-close]')) {
        e.preventDefault();
        this.close();
        return;
      }
      // Remove from drawer (unified: removes both fav + notify if both set)
      const removeBtn = e.target.closest('[data-drawer-remove]');
      if (removeBtn) {
        e.preventDefault();
        this.removeItem(removeBtn.dataset.removeId);
      }
    }

    // --- Favorite toggle (from product button) ---
    toggleFav(btn, continueAsGuest) {
      var self = this;
      var id = btn.dataset.favId;
      var map = this.readFavs();
      var isCurrentlyFav = Boolean(map[id]);

      if (!this._serverMode && !continueAsGuest && !isCurrentlyFav) {
        var loginPopup = document.querySelector('favorites-login-popup');
        if (loginPopup) {
          loginPopup.open(
            'favorite',
            function () {
              self.toggleFav(btn, true);
            },
            btn
          );
          return;
        }
      }

      var newPressed = !isCurrentlyFav;
      btn.setAttribute('aria-pressed', newPressed ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        newPressed
          ? 'Remove ' + btn.dataset.favTitle + ' from favourites'
          : 'Add ' + btn.dataset.favTitle + ' to favourites'
      );

      if (this._serverMode) {
        this.lockButtons(btn);
        this.proxyToggle(this.favProxyUrl(), id, isCurrentlyFav)
          .then(function () {
            if (newPressed) {
              map[id] = {
                handle: btn.dataset.favHandle,
                title: btn.dataset.favTitle,
                url: btn.dataset.favUrl,
                image: btn.dataset.favImage,
                price: btn.dataset.favPrice,
                country: btn.dataset.favCountry,
                year: btn.dataset.favYear,
              };
            } else {
              delete map[id];
            }
            self.writeFavs(map);
            self.syncButtons();
            self.updateCount();
            if (self.classList.contains('is-open')) self.render();
          })
          .catch(function (err) {
            console.error('[Favorite] Proxy toggle failed:', err);
            btn.setAttribute('aria-pressed', isCurrentlyFav ? 'true' : 'false');
            btn.setAttribute(
              'aria-label',
              isCurrentlyFav
                ? 'Remove ' + btn.dataset.favTitle + ' from favourites'
                : 'Add ' + btn.dataset.favTitle + ' to favourites'
            );
          })
          .finally(function () {
            self.unlockButtons(btn);
          });
      } else {
        if (newPressed) {
          map[id] = {
            handle: btn.dataset.favHandle,
            title: btn.dataset.favTitle,
            url: btn.dataset.favUrl,
            image: btn.dataset.favImage,
            price: btn.dataset.favPrice,
            country: btn.dataset.favCountry,
            year: btn.dataset.favYear,
          };
        } else {
          delete map[id];
        }
        this.writeFavs(map);
        this.syncButtons();
        this.updateCount();
        if (this.classList.contains('is-open')) this.render();
      }
    }

    // --- Notify-me toggle (from product button) ---
    toggleNotify(btn, continueAsGuest) {
      var self = this;
      var id = btn.dataset.notifyId;
      var map = this.readNotify();
      var isCurrentlyNotified = Boolean(map[id]);

      if (!this._serverMode && !continueAsGuest && !isCurrentlyNotified) {
        var loginPopup = document.querySelector('favorites-login-popup');
        if (loginPopup) {
          loginPopup.open(
            'notify',
            function () {
              self.toggleNotify(btn, true);
            },
            btn
          );
          return;
        }
      }

      var newNotified = !isCurrentlyNotified;
      btn.setAttribute('aria-pressed', newNotified ? 'true' : 'false');
      var textEl = btn.querySelector('.notify-me-btn__text');
      if (textEl) {
        textEl.textContent = newNotified ? 'Alert set!' : btn.dataset.notifyDefaultText;
      }
      btn.setAttribute(
        'aria-label',
        newNotified
          ? 'Remove notification for ' + btn.dataset.notifyTitle
          : 'Get notified when ' + btn.dataset.notifyTitle + ' is back'
      );

      if (this._serverMode) {
        this.lockButtons(btn);
        this.proxyToggle(this.notifyProxyUrl(), id, isCurrentlyNotified)
          .then(function () {
            if (newNotified) {
              map[id] = {
                handle: btn.dataset.notifyHandle,
                title: btn.dataset.notifyTitle,
                url: btn.dataset.notifyUrl || '',
                image: btn.dataset.notifyImage || '',
                price: btn.dataset.notifyPrice || '',
                country: btn.dataset.notifyCountry || '',
                year: btn.dataset.notifyYear || '',
              };
            } else {
              delete map[id];
            }
            self.writeNotify(map);
            self.syncButtons();
            self.updateCount();
            if (self.classList.contains('is-open')) self.render();
          })
          .catch(function (err) {
            console.error('[Notify-me] Proxy toggle failed:', err);
            btn.setAttribute('aria-pressed', isCurrentlyNotified ? 'true' : 'false');
            var textEl = btn.querySelector('.notify-me-btn__text');
            if (textEl) {
              textEl.textContent = isCurrentlyNotified ? 'Alert set!' : btn.dataset.notifyDefaultText;
            }
            btn.setAttribute(
              'aria-label',
              isCurrentlyNotified
                ? 'Remove notification for ' + btn.dataset.notifyTitle
                : 'Get notified when ' + btn.dataset.notifyTitle + ' is back'
            );
          })
          .finally(function () {
            self.unlockButtons(btn);
          });
      } else {
        if (newNotified) {
          map[id] = {
            handle: btn.dataset.notifyHandle,
            title: btn.dataset.notifyTitle,
            url: btn.dataset.notifyUrl || '',
            image: btn.dataset.notifyImage || '',
            price: btn.dataset.notifyPrice || '',
            country: btn.dataset.notifyCountry || '',
            year: btn.dataset.notifyYear || '',
          };
        } else {
          delete map[id];
        }
        this.writeNotify(map);
        this.syncButtons();
        this.updateCount();
        if (this.classList.contains('is-open')) this.render();
      }
    }

    // --- Remove favorite from drawer ---
    // --- Remove from drawer (removes both fav + notify if both set) ---
    removeItem(id) {
      var self = this;
      var favMap = this.readFavs();
      var notifyMap = this.readNotify();
      var wasFav = Boolean(favMap[id]);
      var wasNotify = Boolean(notifyMap[id]);

      if (!wasFav && !wasNotify) return;

      if (this._serverMode) {
        var promises = [];
        if (wasFav) {
          promises.push(this.proxyToggle(this.favProxyUrl(), id, true));
        }
        if (wasNotify) {
          promises.push(this.proxyToggle(this.notifyProxyUrl(), id, true));
        }
        Promise.all(promises)
          .then(function () {
            if (wasFav) {
              delete favMap[id];
              self.writeFavs(favMap);
            }
            if (wasNotify) {
              delete notifyMap[id];
              self.writeNotify(notifyMap);
            }
            self.syncButtons();
            self.updateCount();
            self.render();
          })
          .catch(function (err) {
            console.error('[Favorites] Proxy remove failed:', err);
          });
      } else {
        if (wasFav) {
          delete favMap[id];
          this.writeFavs(favMap);
        }
        if (wasNotify) {
          delete notifyMap[id];
          this.writeNotify(notifyMap);
        }
        this.syncButtons();
        this.updateCount();
        this.render();
      }
    }

    syncButtons() {
      const favMap = this.readFavs();
      document.querySelectorAll('[data-fav-toggle-item]').forEach((btn) => {
        const fav = Boolean(favMap[btn.dataset.favId]);
        btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
      });

      const notifyMap = this.readNotify();
      document.querySelectorAll('[data-notify-toggle]').forEach((btn) => {
        const notified = Boolean(notifyMap[btn.dataset.notifyId]);
        btn.setAttribute('aria-pressed', notified ? 'true' : 'false');
        var textEl = btn.querySelector('.notify-me-btn__text');
        if (textEl) {
          textEl.textContent = notified ? 'Alert set!' : btn.dataset.notifyDefaultText;
        }
        btn.setAttribute(
          'aria-label',
          notified
            ? 'Remove notification for ' + btn.dataset.notifyTitle
            : 'Get notified when ' + btn.dataset.notifyTitle + ' is back'
        );
      });

      if (this._hydrated) this.syncAccountGrid();
    }

    /* The Favorites and Notify me! pages are rendered from the customer's
       metafields, so a card whose product just left the list stayed on screen
       until a reload. It was most obvious on a product held by BOTH lists,
       where clearing them one at a time left a card that answered to nothing.

       Membership is per page: the favorites page shows the union, so its card
       survives while either list still holds the product; the notify page shows
       one list, so its card leaves with the alert. `syncButtons` already runs
       after every add, remove, proxy round-trip and cross-tab storage event, so
       hanging this off it covers all of them without new call sites. */
    syncAccountGrid() {
      var grid = document.querySelector('[data-account-grid]');
      if (!grid) return;
      var notifyOnly = grid.dataset.accountGrid === 'notify';
      var favMap = this.readFavs();
      var notifyMap = this.readNotify();
      var self = this;
      Array.prototype.slice.call(grid.children).forEach(function (item) {
        var favBtn = item.querySelector('[data-fav-toggle-item]');
        var notifyBtn = item.querySelector('[data-notify-toggle]');
        var id = (favBtn && favBtn.dataset.favId) || (notifyBtn && notifyBtn.dataset.notifyId);
        if (!id) return;
        var stillListed = notifyOnly
          ? Boolean(notifyMap[id])
          : Boolean(favMap[id]) || Boolean(notifyMap[id]);
        if (!stillListed) self.dropGridItem(item);
      });
    }

    dropGridItem(item) {
      if (item.hasAttribute('data-dropping')) return;
      item.setAttribute('data-dropping', '');
      var self = this;
      var done = function () {
        item.remove();
        self.syncAccountEmptyState();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        done();
        return;
      }
      item.addEventListener('transitionend', done, { once: true });
      // A card that is scrolled out of view (or in a tab the browser has
      // throttled) may never fire transitionend, and it must not survive that.
      setTimeout(done, 400);
    }

    syncAccountEmptyState() {
      var grid = document.querySelector('[data-account-grid]');
      if (!grid || grid.children.length) return;
      var list = grid.closest('[data-account-list]');
      var empty = document.querySelector('[data-account-empty]');
      if (list) list.hidden = true;
      if (empty) empty.hidden = false;
    }

    updateCount() {
      const favN = Object.keys(this.readFavs()).length;
      const notifyN = Object.keys(this.readNotify()).length;
      const total = favN + notifyN;
      document.querySelectorAll('[data-fav-count]').forEach((el) => {
        el.textContent = total;
        el.hidden = total < 1;
      });
    }

    esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '\u0026amp;')
        .replace(/</g, '\u0026lt;')
        .replace(/>/g, '\u0026gt;')
        .replace(/"/g, '\u0026quot;')
        .replace(/'/g, '\u0026#39;');
    }

    getTagline(item) {
      let tagline = String(item.country || '').trim();
      let year = parseInt(item.year);
      let centuryText = '';

      if (isFinite(year)) {
        if (String(year) != String(item.year).trim()) {
          centuryText = item.year;
        } else {
          if (year > 0) {
            const century = Math.floor((year + 99) / 100);
            const centuryUnits = century % 10;
            switch (centuryUnits) {
              case 1:
                centuryText = century.toFixed(0) + (century != 11) ? 'st' : 'th';
                break;
              case 2:
                centuryText = century.toFixed(0) + (century != 12) ? 'nd' : 'th';
                break;
              case 3:
                centuryText = century.toFixed(0) + (century != 13) ? 'rd' : 'th';
                break;
              default:
                centuryText = century.toFixed(0) + 'th';
                break;
            }
          }
          centuryText += ' Century';
        }
        if (tagline != '') {
          tagline += ', ';
        }
        tagline += centuryText;
      }
      return tagline;
    }

    render() {
      const favMap = this.readFavs();
      const notifyMap = this.readNotify();
      const favIds = Object.keys(favMap);
      const notifyIds = Object.keys(notifyMap);

      if (!favIds.length && !notifyIds.length) {
        this.body.innerHTML =
          '<div class="favorites-drawer__empty">Your favorites is looking a little too minimalist. Start exploring and adding items to create your personalized collection!</div>';
        this.footer.hidden = true;
        return;
      }

      const rows = [];

      // Favorites first (including those also in notify-me)
      favIds.forEach((id) => {
        const it = favMap[id];
        const img = it.image ? `<img src="${this.esc(it.image)}" alt="${this.esc(it.title)}" loading="lazy">` : '';

        rows.push(`<li class="fav-line">
          <a href="${this.esc(it.url)}" class="fav-line__media">${img}</a>
          <div class="fav-line__body">
            <div class="fav-line__info">
              <a href="${this.esc(it.url)}" class="fav-line__title">${this.esc(it.title)}</a>
              <p class="fav-line__info">${this.esc(this.getTagline(it))}</p>
              <p class="fav-line__price">${this.esc(it.price)}</p>
            </div>
            <button type="button" class="fav-line__remove" data-drawer-remove data-remove-id="${this.esc(
              id
            )}" aria-label="Remove">Remove</button>
          </div>
        </li>`);
      });

      // Then notify-me items not already favorited
      notifyIds.forEach((id) => {
        if (favMap[id]) return; // skip if already a favorite
        const it = notifyMap[id];
        const img = it.image ? `<img src="${this.esc(it.image)}" alt="${this.esc(it.title)}" loading="lazy">` : '';
        rows.push(`<li class="fav-line">
          <a href="${this.esc(it.url)}" class="fav-line__media">${img}</a>
          <div class="fav-line__body">
            <div class="fav-line__info">
              <a href="${this.esc(it.url)}" class="fav-line__title">${this.esc(it.title)}</a>
              <p class="fav-line__info">${this.esc(this.getTagline(it))}</p>
              <p class="fav-line__price">${this.esc(it.price)}</p>
            </div>
              <button type="button" class="fav-line__remove" data-drawer-remove data-remove-id="${this.esc(
                id
              )}" aria-label="Remove">Remove</button>
          </div>
        </li>`);
      });

      this.body.innerHTML = `<ul class="favorites-drawer__items">${rows.join('')}</ul>`;
      this.footer.hidden = false;
    }

    open() {
      this.render();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      if (this.panel) this.panel.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
    }
  }

  if (!customElements.get('favorites-drawer')) {
    customElements.define('favorites-drawer', FavoritesDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"] && !Shopify.designMode) return;
  try {
    
class FaqAccordion extends HTMLElement {
	connectedCallback() {
		this.buttons = this.querySelectorAll('button');
		this.buttons.forEach((btn) => btn.addEventListener('click', () => this.toggle()));
	}
	toggle() {
		const open = !this.hasAttribute('open');
		// The app tracks a single activeIndex: opening a row closes the others.
		if (open) {
			this.parentElement.querySelectorAll('faq-accordion[open]').forEach((other) => {
				if (other !== this) other.setOpen(false);
			});
		}
		this.setOpen(open);
	}
	setOpen(open) {
		this.toggleAttribute('open', open);
		this.buttons.forEach((btn) => btn.setAttribute('aria-expanded', open));
	}
}
if (!customElements.get('faq-accordion')) customElements.define('faq-accordion', FaqAccordion);

  } catch(e) { console.error(e); }
})();
})();
